const BecomeShareHolder = () => {
    return (
        <div>
            <h1>Becomeshareholder</h1>
        </div>
    );
};

export default BecomeShareHolder;
